<script>
  import { onMount } from "svelte";
  import JobStatus from "./JobStatus.svelte";

  const redirect = window.location.pathname;
  let userInfo = undefined;

  onMount(async () => {
    userInfo = await getUserInfo();
  });

  async function getUserInfo() {
    try {
      const response = await fetch("/.auth/me");
      const payload = await response.json();
      const { clientPrincipal } = payload;
      return clientPrincipal;
    } catch (error) {
      console.error("No profile could be found");
      return undefined;
    }
  }
</script>

<nav class="navbar " aria-label="main navigation">
  <div class="navbar-brand ">
    <div class="navbar-item is-clickable">
      <span class="title is-3 is-family-primary has-text-black">celver </span>
    </div>
  </div>
  <div id="navbarMenuHeroA" class="navbar-menu">
    <div class="navbar-end">
      <JobStatus bind:userInfo />
      {#if !userInfo}
        <span class="navbar-item">
          <a
            class="button is-primary is-outlined"
            href={`/.auth/login/aad?post_login_redirect_uri=${redirect}`}
          >
            <span class="icon">
              <i class="fas fa-sign-in" />
            </span><span>Login</span>
          </a>
        </span>
      {/if}
      <span class="navbar-item">
        <a class="button is-primary" href="https://app.powerbi.com">
          <span class="icon">
            <i class="fas fa-chart-column" />
          </span>
          <span>Power BI</span>
        </a>
      </span>
    </div>
  </div>
</nav>
